import { PrismaClient } from '@prisma/client';

const globalForPrisma = globalThis;

// Append connection pool settings to DATABASE_URL for Supabase pooler
const getDatabaseUrl = () => {
  const baseUrl = process.env.DATABASE_URL || '';
  // Add pgbouncer and connection pool settings if not already present
  if (baseUrl && !baseUrl.includes('pgbouncer=true')) {
    const separator = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${separator}pgbouncer=true&connection_limit=1`;
  }
  return baseUrl;
};

const prisma =
  globalForPrisma.prisma ??
  new PrismaClient({
    log:
      process.env.NODE_ENV === 'development'
        ? ['query', 'error', 'warn']
        : ['error'],
    datasources: {
      db: {
        url: getDatabaseUrl(),
      },
    },
  });

// Cache in all environments: a second client would double connections against a small pool
globalForPrisma.prisma = prisma;

export default prisma;

// Connection health check
export async function checkDatabaseConnection() {
  try {
    await prisma.$queryRaw`SELECT 1`;
    return { status: 'connected', timestamp: new Date().toISOString() };
  } catch (error) {
    console.error('Database connection failed:', error);
    return {
      status: 'disconnected',
      error: error.message,
      timestamp: new Date().toISOString(),
    };
  }
}

// Graceful shutdown
export async function disconnectDatabase() {
  try {
    await prisma.$disconnect();
  } catch (error) {
    console.error('Error disconnecting database:', error);
  }
}

// Process cleanup
process.on('beforeExit', async () => {
  await disconnectDatabase();
});

process.on('SIGINT', async () => {
  await disconnectDatabase();
  process.exit(0);
});

process.on('SIGTERM', async () => {
  await disconnectDatabase();
  process.exit(0);
});
